import Decimal from "decimal.js";

export const formatCurrency = (value) => {
  if (value == null || value === "" || isNaN(value)) return "0,00";

  const decimalValue = new Decimal(value).toDecimalPlaces(2, Decimal.ROUND_HALF_UP);

  return decimalValue.toNumber().toLocaleString("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

export const invoicesStatusChip = {
  paid: {
    label: 'Paga',
    color: 'success',
    description: 'Total cobrado foi pago por completo.',
  },
  partially_paid: {
    label: 'Paga parcialmente',
    color: 'warning',
    description: 'Total cobrado ainda não foi pago por completo.',
  },
  received: {
    label: 'Recebida',
    color: 'success',
    description: 'Total pago foi recebido por completo pelo provedor financeiro.',
  },
  partially_received: {
    label: 'Recebida parcialmente',
    color: 'warning',
    description: 'Total pago ainda não foi recebido por completo pelo provedor financeiro.',
  },
  pending: {
    label: 'Aguardando pagamento',
    color: 'info',
    description: 'Fatura disponível para baixa manual de pagamento.',
  },
  overdue: {
    label: 'Vencida',
    color: 'error',
    description: 'Fatura com valores em aberto que passaram da data de vencimento.',
  },
  canceled: {
    label: 'Cancelada',
    description: 'Fatura sem validade financeira. Não é necessário realizar uma ação.',
  },
  refunded: {
    label: 'Reembolsada',
    description: 'Total pago devolvido ao cliente.',
  },
  expired: {
    label: 'Expirada',
    description: 'Fatura sem validade financeira. Precisa ser reemitida.',
  },
  in_protest: {
    label: 'Protestada',
    description: 'Fatura com estorno aprovado pelo provedor financeiro.',
  },
  chargeback: {
    label: 'Em contestação',
    description: 'Fatura com estorno solicitado pelo cliente.',
  },
  externally_paid: {
    label: 'Paga externamente',
  },
};

export const getInvoiceStatus = (status) => {
  const key = status.toLowerCase().replace(/\s/g, '');
  const info = invoicesStatusChip[key]; 

  return {
    label: info?.label || status,
    color: info?.color,
    description: info?.description || '',
  };
};